export const ENABLE_INVOICE_PROCESSING = process.env.REACT_APP_ENABLE_INVOICE_PROCESSING;
export const APP_THEME = process.env.REACT_APP_APP_THEME;
export const PUBLIC_PATH = process.env.REACT_APP_PUBLIC_PATH;
export const PAYMENT_AGENT = process.env.REACT_APP_PAYMENT_AGENT;
export const ENABLE_INVOICE_CREATION = process.env.REACT_APP_ENABLE_INVOICE_CREATION;
